require('./userRoleChangeDialog.style.scss');

const HELP_ROLE_CHANGE = 'role-change';
const HELP_DEFAULT_ROLE_CHANGE = 'default-role-change';
class UserRoleChangeDialogController {
    constructor($scope, $timeout, $filter, $attrs, dialogService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$attrs = $attrs;
        this.dialogService = dialogService;
    }

    $onInit() {
        if ((this.selectedUser && this.selectedUser[0].type === "USER") || this.$attrs.eventId === 'default-role-change-dialog') {
            this.rolesList = this.rolesList.filter(role => role.name !== "PROTEGE_OPERATOR");
        }

        this.selectedUserRoles = this.selectedRole.map(((roleA) => {
            return this.rolesList.filter((role) => role.name === roleA.name)[0]
        }));

        this.id = this.$attrs.eventId + '-close';
        this.closeId = { close: this.$attrs.eventId + '-close', closeIcon: this.$attrs.eventId + '-close-icon', closeTitle: this.$filter('translate')('common.form.default.btn.close.label') };
        this.actionButton = [
            {
                title: this.$filter('translate')('toolbar.default.save.label'),
                action: () => this.onUserRoleChange(),
                id: this.$attrs.eventId + '-change',
                type: 'submit',
                isDisabled: () => this.isSaveRolesDisabled()
            }
        ];
    }

    onUserRoleChange() {
        let roles;
        if (this.$attrs.eventId !== 'default-role-change-dialog') {
            roles = [];
            this.selectedUserRoles.forEach((role) => {
                roles.push(role.value)
            })
        } else {
            roles = this.selectedUserRoles[0].value;
        }
        if (this.isOwnRole) {
            this.dialogService.showYesNo(this.$filter('translate')("main.nav.top.admin.userRoles.change.text"), this.$filter('translate')("main.nav.top.admin.userRoles.change.title"), '', 'user-role-change-confirmation')
                .then(result => {
                    if (!result) return false;
                    else {
                        this.onUserSave(roles);
                    }
                });
        } else {
            this.onUserSave(roles);
        }
    }

    onUserSave(roles) {
        this.busy = this.onSave({ role: roles }).then(() => {
            this.onClose();
        })
    }

    onOpen() {
        this.modalTitle = this.title;
        this.helpId = this.$attrs.eventId !== 'default-role-change-dialog' ? HELP_ROLE_CHANGE : HELP_DEFAULT_ROLE_CHANGE;

    }

    onClose() {
        this.selectedUserRoles = [];
        this.showModal = false;
    }

    isSaveRolesDisabled() {
        return !this.selectedUserRoles || this.selectedUserRoles.length === 0;
    }
}

UserRoleChangeDialogController.$inject = ['$scope', '$timeout', '$filter', '$attrs', 'dialogService'];

const userRoleChangeDialogComponent = {
    controller: UserRoleChangeDialogController,
    template: require('./userRoleChangeDialog.template.html'),
    bindings: {
        showModal: '=',
        title: '@?',
        onSave: '&',
        isSubModal: '<?',
        rolesList: '<',
        selectedRole: '<',
        isOwnRole: '<',
        selectedUser: '<?'
    }
};

module.exports = userRoleChangeDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/userRoles/userRoleChangeDialog/userRoleChangeDialog.component.js